module.exports = __webpack_public_path__ + "static/softbank-9030faa52df7cb9d14f2de2971b839b7.mp4";